<template>
<div>
    <div class="container">
        <div v-if="isFreddiesCustomer">
            <heading :text="fields.freddies_customer_heading" size="large"></heading>
            <p v-text="fields.freddies_customer_paragraph"></p>
            <div class="postcode-container">
                <input
                    id="account-first-name"
                    type="text"
                    class="input__field"
                    v-model="postcode"
                >

                <submit-button
                    class="btn--half"
                    color="green"
                    @click="submit"
                    :hoverable="false"
                    v-text="fields.check_postcode_text"></submit-button>

            </div>

            <div class="mt-4">
                <p v-text="postcodeParagraph"></p>
                <heading :text="postcodeSubHeading"></heading>
                <p class="mt-4" v-text="postcodeSubParagraph"></p>
            </div>
        </div>

        <div v-if="showAddress">
            <TRTAddress :fields="fields"></TRTAddress>
        </div>
    </div>
</div>

</template>

<script>
import { mapGetters } from 'vuex';
import { Heading } from '@freddiesflowers/frontend-component-library';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import TRTAddress from './TRTAddress.vue';

export default {
    name: 'list',
    props: {
        fields: {
            type: Object,
        },
        option: {
            type: String,
        },
    },
    data() {
        return {
            postcode: '',
        };
    },
    components: {
        SubmitButton,
        TRTAddress,
        Heading,
    },
    methods: {
        submit() {
            this.getPackageCollectionStatus();
        },
        getPackageCollectionStatus() {
            this.$store.dispatch('address/getPackageCollectionStatus', this.postcode);
        },
    },
    computed: {
        ...mapGetters({
            collectsPackaging: 'address/isCollectsPackaging',
            isPostcodeStatusFetched: 'address/isPostcodeStatusFetched',
        }),
        isFreddiesCustomer() {
            return this.option && this.option === 'Yes';
        },
        isNotFreddiesCustomer() {
            return this.option && this.option === 'No';
        },
        postcodeData() {
            if (this.isPostcodeStatusFetched) {
                // eslint-disable-next-line
                const collectsPackagingFields = this.fields.postcode_result.filter(item => item.collects_packaging == this.collectsPackaging);
                return collectsPackagingFields;
            }
            return [];
        },
        postcodeParagraph() {
            return this.postcodeData[0]?.paragraph;
        },
        postcodeSubHeading() {
            return this.postcodeData[0]?.secondary_heading || '';
        },
        postcodeSubParagraph() {
            return this.postcodeData[0]?.secondary_paragraph || '';
        },
        showAddress() {
            return this.isNotFreddiesCustomer || (this.isPostcodeStatusFetched && !this.collectsPackaging);
        },
    },
};
</script>

<style lang="scss" scoped>
        .container {
            margin: 40px auto;
            text-align: center;
            width: 80%;
        }
        .postcode-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin: 40px auto;
            max-width: 800px;
        }
        .input__field {
            height: 48px;
            max-width: 200px;
            margin-right: 10px;
        }

    @media (max-width: 768px) {
        .postcode-container {
            justify-content: space-around;
            align-items: flex-start;
        }
        .input__field {
            margin-right: 0px;
            margin-bottom: 10px;
            max-width: 150px;
        }
    }
</style>
